import React from "react";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { StyledBlackInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import BrandStoresFilter from "../../../../components/commonComponents/Filters/BrandStoresFilter";
import BrandWeeks from "../../filters/shared/BrandWeeks";
import BrandAnalysisGroupMultiple from "../../filters/shared/BrandAnalysisGroupMultiple";

const BrandReportFilter = () => {

  return (
    <>
      {/* ------- disclaimer text for brand report --------- */}
      <Box height={10} />
      <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
        Share the report of this campaign with brands. Below, you can specify which information is shared with them. Use the Brand View in the report to verify that your settings are correct. You can update these settings even after the report has been shared.
      </StyledBlackInformationTypography>
      <Box height={20} />
      <Box>
        <Typography variant="h6">Impressions Filter</Typography>
        <Box height={20} />
        {/* ------- stores ------- */}
        <BrandStoresFilter usedFor={"impression_filter"} />
      </Box>
      <Box height={40} />
      <Box>
        <Typography variant="h6">Performance Filter</Typography>
        <Box height={20} />
        <Stack direction={"row"} spacing={2}>
          {/* ------- stores ------- */}
          <BrandStoresFilter usedFor={"performance_filter"} />
          {/* ------- callendar weeks ------- */}
          <BrandWeeks />
          {/* ------- analysis group ------- */}
          <BrandAnalysisGroupMultiple />
        </Stack>
        <Box height={40} />
      </Box>
    </>
  );
};

export default BrandReportFilter;
